import { Stack } from "@mui/material";
import ClientsTabs from "./tabs";

const Clients = () => {
  return (
    <Stack maxWidth={{ xs: "100%", md: `calc(100vw - 316px)` }}>
      <ClientsTabs />
    </Stack>
  );
};

export default Clients;
